var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmFail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.80289 5.89511C7.27607 5.3683 6.42193 5.3683 5.89511 5.89511C5.3683 6.42193 5.3683 7.27607 5.89511 7.80289L10.0922 12L5.89511 16.1971C5.3683 16.7239 5.3683 17.5781 5.89511 18.1049C6.42193 18.6317 7.27607 18.6317 7.80289 18.1049L12 13.9078L16.1971 18.1049C16.7239 18.6317 17.5781 18.6317 18.1049 18.1049C18.6317 17.5781 18.6317 16.7239 18.1049 16.1971L13.9078 12L18.1049 7.80289C18.6317 7.27607 18.6317 6.42193 18.1049 5.89511C17.5781 5.3683 16.7239 5.3683 16.1971 5.89511L12 10.0922L7.80289 5.89511Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmFail);
export default __webpack_public_path__ + "static/media/confirm_fail.ddc8db0f.svg";
export { ForwardRef as ReactComponent };